module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e750462991209bc82f6d0ab0783943c0.png";